// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"8c89a84d","787":"919a69c7"}[chunkId] + ".chunk.js";
};